// @ vendors
const Immutable = require('immutable');
// @ commons
import { formatText } from 'core/i18n';
// @ constants
const actionTypes = require('constants/actionTypes');

const setInitialState = () => {
    return Immutable.Map().merge({
        error: '',
        fetchSuccess: false,
        byId: {},
        byOrder: [],
        batchStatus: false,
    });
};

const initialState = setInitialState();

const getFullName = (id, name, lastName1, lastName2) => {
    let fullName = formatText('jointHolderStatus-holderName', [id]);

    if (name && lastName1) {
        fullName = `${name} ${lastName1} ${lastName2 ? lastName2 : ''}`;
    }

    return fullName;
};

const updateJointHolders = holders => {
    let byId = {};
    let byOrder = [];
    let date = new Date().valueOf();
    let id = 1;
    let batchStatus = false;

    holders.forEach(holder => {
        const holderId = holder.id || id + date;
        const parsedHolders = {
            expiration: holder.expirationTime || 0,
            name: getFullName(id, holder.name, holder.lastname1, holder.lastname2),
            status: holder.onboardingStatus || '',
            type: holder.accountType || '',
            checkOpenCredit: holder.checkOpenCredit || '',
            editable: holder.editable || false,
            dispensable: holder.dispensable || false,
            email: holder.email,
            docNumber: holder.docNumber,
        };

        byId[holderId] = parsedHolders;
        byOrder.push(holderId);

        if (holder.onboardingStatus === 'batch') {
            batchStatus = true;
        }

        ++id;
    });

    return {
        byId: byId,
        byOrder: byOrder,
        fetchSuccess: true,
        batchStatus,
    };
};

const jointHoldersStatus = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.FETCH_JOINT_HOLDERS_SUCCESS:
            return state.merge(updateJointHolders(action.data));
        case actionTypes.FETCH_JOINT_HOLDERS_FAILURE:
            return state.merge({
                error: action.error,
            });
        default:
            return state;
    }
};

module.exports = jointHoldersStatus;
